import { render } from "./ApartmentsHeader.vue?vue&type=template&id=227a6882"
import script from "./ApartmentsHeader.vue?vue&type=script&lang=js"
export * from "./ApartmentsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__